import React from 'react'
import { Tooltip } from '@mui/material'

import { formatBusinessDateTime } from '../../utils/date'
import { deliveryLabel, deliveryTone } from './deliveryStatus'

const TONE_CLASSES = {
  success: 'bg-success-light text-success-main',
  warning: 'bg-warning-light text-warning-main',
  error: 'bg-error-light text-error-main',
  neutral: 'bg-[var(--color-gray-100)] dark:bg-white/[0.06] text-text-secondary',
}

const DELIVERED_NOTE = "Delivered means the recipient's mail server accepted it; it cannot tell the inbox from the spam folder."
const SPAM_NOTE = 'The recipient marked this email as spam.'
const DELIVERED_STATUSES = ['delivered', 'opened', 'clicked']

const hasValue = (value) => value !== undefined && value !== null && value !== ''

const notesFor = (channel, status) => {
  if (channel !== 'email') return []
  if (DELIVERED_STATUSES.includes(status)) return [DELIVERED_NOTE]
  if (status === 'spam') return [SPAM_NOTE]
  return []
}

const DeliveryStatusBadge = ({ delivery, channel }) => {
  if (!delivery?.status) return null

  const label = deliveryLabel(channel, delivery.status)
  const tone = deliveryTone(channel, delivery.status)
  const lines = [
    formatBusinessDateTime(delivery.at),
    hasValue(delivery.reason) ? delivery.reason : '',
    hasValue(delivery.errorCode) ? `Error code ${delivery.errorCode}` : '',
    ...notesFor(channel, delivery.status),
  ].filter(Boolean)

  const title = (
    <div className="flex flex-col gap-1">
      <div className="font-semibold">{label}</div>
      {lines.map((line, index) => (
        <div key={index}>{line}</div>
      ))}
    </div>
  )

  return (
    <Tooltip title={title} arrow placement="top" enterTouchDelay={0}>
      <span
        data-testid="delivery-status"
        className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap ${TONE_CLASSES[tone]}`}
      >
        {label}
      </span>
    </Tooltip>
  )
}

export default DeliveryStatusBadge
